import React, { useEffect, useState } from "react";
import { LazyLoadComponent } from "react-lazy-load-image-component";
import { useDispatch, useSelector } from "react-redux";
import toastr from "toastr";
import { fetchFAQ } from "../../redux/actions/hotelInfoAction";
import { postFAQApi } from "../../Services/mainPageService";
import { fireGtmEvent } from "../../utils/googleAnalytics";
import "./FAQ.css";
import { useTranslation } from "react-i18next";

const FAQ = () => {
  const {
    hotelData: { id },
    faqs,
  } = useSelector((state) => state.hotelInfo);

  const dispatch = useDispatch();

  const { t } = useTranslation();

  const [isQuestion, setIsQuestion] = useState();
  const [question, setQuestion] = useState();
  const [email, setEmail] = useState();
  const [selected, setSelected] = useState();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const obj = {
      email,
      question,
      hotelId: id,
    };

    const response = await postFAQApi(obj);

    fireGtmEvent("added_faq", {
      email,
      question,
    });

    if (response.status === 200) {
      toastr.success(response.message);
    } else {
      toastr.error(response.error);
    }
    setEmail("");
    setQuestion("");
  };

  const toggle = (i) => {
    if (selected === i) {
      return setSelected(null);
    }
    setSelected(i);
  };

  return (
    <LazyLoadComponent afterLoad={() => fireGtmEvent("faq_viewed")}>
      <div className="mainpage__faq" id="faq">
        {faqs?.map((item, idx) => {
          return (
            item?.answer && (
              <div className="faqItem" key={idx}>
                <div className="faqTitle" onClick={() => toggle(idx)}>
                  <p>{item?.modifiedQuestion || item?.originalQuestion}</p>
                  <span>{selected === idx ? "-" : "+"}</span>
                </div>
                <div
                  key={idx}
                  className={
                    selected === idx ? "faqContent show" : "faqContent"
                  }
                >
                  <span> {item?.answer}</span>
                </div>
              </div>
            )
          );
        })}

        <div className="mainpage__faqBtn">
          {isQuestion ? (
            <form onSubmit={handleSubmit}>
              <input
                type="text"
                required
                placeholder={t("please_enter_your_question")}
                value={question}
                onChange={(e) => setQuestion(e.target.value)}
              />
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder={t("enter_email")}
              />
              <input type="submit" value={t("submit")} />
            </form>
          ) : (
            <button onClick={() => setIsQuestion(!isQuestion)}>
              {t("ask_a_question")}
            </button>
          )}
        </div>
      </div>
    </LazyLoadComponent>
  );
};

export default FAQ;
